import React from "react";
import Loader from "./Loader";

export default function Song({ currentSong, isLoading }) {
  return (
    <div className=" w-full h-[65%] absolute top-40 sm:top-32  max-w-full font-varela dark:text-[#FFFFFF] text-[#0d0f17] rounded-sm ">
      <div className="p-6 flex flex-col justify-center items-center text-center">
        <div className="cover">
          {!isLoading ? <img
            src={currentSong.imageUrl}
            alt="song-cover"
            className="rounded-full h-[20rem] w-[20rem] object-cover"
          /> : <Loader />}
          
        </div>
        <div className="text-ellipsis overflow-hidden max-w-full">
          <p className="text-2xl mt-10 truncate">{currentSong.title}</p>
          {/* <p className="text-xl p-1 truncate">{currentSong.artist}</p> */}
        </div>
      </div>
    </div>
  );
}
